import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ListPage } from '../../pages/list/list';

import { VacacionesPage } from '../../pages/vacaciones/vacaciones';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { EventModalPage} from '../../pages/event-modal/event-modal';
import * as XLSX from '../../xlsx';

import { File } from '@ionic-native/file';

@Component({
  selector: 'page-trabajadores',
  templateUrl: 'trabajadores.html'
})

export class TrabajadoresPage {
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",password1: "",empresa1: "",obra1: "",turno1: "",horas1: "",activo1: "",alias1:"",tarjeta1:""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  numerodetrabajadores = 0;
  empresas;
  obras;
  puestos;
  turnos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  trabajadoresKeys;
  values:Array<string> = [];
  rs_xls;
  muestragif;
  TrabajadorCompleto = {};
  posicion: number = 0;
  pos: number = 0 ;
  itemData: any = [];
  items = [];

  constructor(
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider,
    public file: File
    ) {                    
            
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;
      
      this.muestragif = "si";
          
  
      this.myForm = this.fb.group({

      codigo: [''],
      nombre: ['' ],
      password: ['' ],
      empresa: ['' ],
      obra: ['' ],
      turno: ['' ],
      horas: ['' ],
      activo: [''],
      alias: [''],
      tarjeta: ['']
    
     });

 this.myForm1 = this.fb.group({

      codigo1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      password1: ['', [Validators.required]],
      empresa1: ['', [Validators.required]],
      obra1: ['', [Validators.required]],
      turno1: ['', [Validators.required]],
      horas1: ['', [Validators.required]],
      activo1: ['', [Validators.required]],
      alias1: ['', [Validators.required]],
      tarjeta1: ['', [Validators.required]]
    
     });
   

    this.obtenertrabajadores(this.valo);

  

  }


/*
subirficheros(trabajador){

 let myModal = this.modalCtrl.create(EventModalPage, {
              'trabajador':trabajador,
              'codigo': '',
              'tabla': "trabajadores",
              'caption': 'Editar'
            }
            );

            myModal.onDidDismiss((data: any) => { 
                       
             //  this.navCtrl.setRoot(this.navCtrl.getActive().component);   
        
            }); 
            myModal.present();

} 
*/
subirficheros(codigo){
//console.log("MI CODIGOOO " + codigo);
 let myModal = this.modalCtrl.create(EventModalPage, {
              'codigo':codigo,
            }
            );

            myModal.onDidDismiss((data: any) => { 
                       
             //  this.navCtrl.setRoot(this.navCtrl.getActive().component);   
        
            }); 
            myModal.present();
} 

   buscartrabajadores(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    //console.log("Vamos a buscar :" + neutro);
    this.rs_xls = [];

    this.funciones.obtienetrabajadores(neutro).then(
          data => {

          this.trabajadores = data;
           

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   obtenerpuestos(filtro){

    this.funciones.obtienepuestos(filtro).then(
          data => {

          this.puestos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerempresas(filtro){

    this.funciones.obtieneempresas(filtro).then(
          data => {

          this.empresas = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerobras(filtro){

    this.funciones.obtieneobrasconfiltro(filtro).then(
          data => {

          this.obras = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


    obtenerturnos(filtro){

    this.funciones.obtieneturnos(filtro).then(
          data => {

          this.turnos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


  obtenertrabajadores(filtro){

    this.rs_xls = [];
    this.muestragif = "si";

    this.funciones.obtienetrabajadores(filtro).then(
          data => {

          this.trabajadores = data;

          //alert(JSON.stringify(data));
          
          this.obtenerobras(this.valo);
          this.obtenerempresas(this.valo);
          this.obtenerturnos(this.valo);
          this.obtenerpuestos(this.valo);
          
          this.numerodetrabajadores =0;

          for (var _i = 0; _i < this.trabajadores.length; _i++) {

            if (this.trabajadores[_i].ACTIVO=="SI"){
              this.numerodetrabajadores ++;
            }

          }

              this.muestragif = "no";
    

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )


  }


editartrabajadorestodos(){

 let alert = this.alertCtrl.create({
      title: 'Grabar',
      message: '¿Confirma grabar los registros?',
      cssClass: 'alertCustomCss',
      buttons: [{
          text: 'No',
          role: 'No',
          handler: () => { 

          }
        },{
          text: 'Si',
          handler: () => {

             for (var _i = 0; _i < this.trabajadores.length; _i++) {
                    this.editartrabajadores2(_i);


                  }  
          }
        }
      ]
    });
    
    alert.present();
  }



 editartrabajadores2(index){



  if (this.trabajadores[index].FECHAALTA){  }else{ this.trabajadores[index].FECHAALTA="2018-01-01"; }
  if (this.trabajadores[index].PUESTO){     }else{ this.trabajadores[index].PUESTO="Trabajador";    }
  if (this.trabajadores[index].PRECIOHORA){ }else{ this.trabajadores[index].PRECIOHORA="0";         }

  this.TrabajadorCompleto["user"] = this.variables.CLIENTES_RAZSOCIAL;
  this.TrabajadorCompleto["codigo"] = this.trabajadores[index].CODIGO;
  this.TrabajadorCompleto["nombre"] = this.trabajadores[index].NOMBRE;
  this.TrabajadorCompleto["empresa"] = this.trabajadores[index].EMPRESA;
  
  //console.log(this.TrabajadorCompleto["empresa"]);
  
  this.TrabajadorCompleto["password"] = this.trabajadores[index].PASSWORD;
  this.TrabajadorCompleto["obra"] = this.trabajadores[index].OBRA;
  this.TrabajadorCompleto["turno"] = this.trabajadores[index].TURNO;
  this.TrabajadorCompleto["horas"] = this.trabajadores[index].HORAS;
  this.TrabajadorCompleto["activo"] = this.trabajadores[index].ACTIVO;
  this.TrabajadorCompleto["fechaalta"] = this.trabajadores[index].FECHAALTA;
  this.TrabajadorCompleto["puesto"] = this.trabajadores[index].PUESTO;
  this.TrabajadorCompleto["preciohora"] = this.trabajadores[index].PRECIOHORA;
  this.TrabajadorCompleto["email"] = this.trabajadores[index].EMAIL;
  this.TrabajadorCompleto["zona"] = this.trabajadores[index].ZONA;
  this.TrabajadorCompleto["alias"] = this.trabajadores[index].ALIAS;
  this.TrabajadorCompleto["tarjeta"] = this.trabajadores[index].TARJETA;

  this.funciones.editatrabajador2(this.TrabajadorCompleto).then(
        data => {
  
          if (data[0].RESULTADO=="OK"){



            this.numerodetrabajadores =0;

            for (var _i = 0; _i < this.trabajadores.length; _i++) {
  
              if (this.trabajadores[_i].ACTIVO=="SI"){
                this.numerodetrabajadores ++;
              }
  
              
            }


          }else{


            let alert = this.alertCtrl.create({
                title: 'Resultado',
                message: 'Error:' + JSON.stringify(data),
                cssClass: 'alertCustomCss'
             
              });
              alert.present();
         }

        },
        err=>{
          console.log(err);
         }

        )


  } // fin picando

 /* editartrabajadores(index){


   if (this.trabajadores[index].FECHAALTA){  }else{ this.trabajadores[index].FECHAALTA="2018-01-01"; }
   if (this.trabajadores[index].PUESTO){     }else{ this.trabajadores[index].PUESTO="Trabajador";    }
   if (this.trabajadores[index].PRECIOHORA){ }else{ this.trabajadores[index].PRECIOHORA="0";         }
    this.funciones.editatrabajador(this.trabajadores[index].CODIGO,this.trabajadores[index].NOMBRE, this.trabajadores[index].EMPRESA, this.trabajadores[index].OBRA, this.trabajadores[index].TURNO, this.trabajadores[index].HORAS, this.trabajadores[index].ACTIVO, this.trabajadores[index].FECHAALTA, this.trabajadores[index].PUESTO, this.trabajadores[index].PRECIOHORA).then(
          data => {
            this.trabajadores = data;
            this.obtenertrabajadores(this.valo);
           }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }
*/
  registro(){

     if (this.formulario.activo1=='') {
       this.formulario.activo1 = "SI";
     }

    // var passProvisional = "control01";
    if (this.formulario.alias1==""){
      this.formulario.alias1="alias";
    }
    if (this.formulario.tarjeta1==""){
      this.formulario.tarjeta1="tarjeta";
    }

   this.funciones.grabartrabajadores(this.formulario.codigo1, this.formulario.nombre1, this.formulario.password1, this.formulario.empresa1, this.formulario.obra1, this.formulario.turno1, this.formulario.horas1, this.formulario.activo1,this.formulario.alias1,this.formulario.tarjeta1).then(
     data => {
          this.resultado = data;

          this.obtenertrabajadores(this.valo);

          this.formulario.codigo1="";
          this.formulario.nombre1="";
          this.formulario.horas1="";
          
           
        })


  }

   borrar(id,codigo,nombre){

   

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar el trabajador? '  + codigo + ' -> ' + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {


               this.funciones.deltrabajadores(id).then(
                   data => {
                    
                    this.obtenertrabajadores(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }


   openPicajes(codigotrabajador,nombretrabajador){

    this.variables.CODIGOTRABAJADOR = codigotrabajador;
    this.variables.NOMBRETRABAJADOR = nombretrabajador;

    this.navCtrl.push(PicajesPage);
  }

   doInfinite(infiniteScroll) {
        setTimeout(() => {
          this.pos = this.posicion;

        for (let _i = 0; _i < 5; _i++) {
          if ( this.posicion < this.trabajadores.length){
              //this.items.push( data[_i] );
              
            this.rs_xls.push({
              CODIGO: "" + this.trabajadores[_i].CODIGO,
              NOMBRE: "" + this.trabajadores[_i].NOMBRE,
              EMPRESA: "" + this.trabajadores[_i].EMPRESA,
              OBRA: "" + this.trabajadores[_i].OBRA,
              TURNO: "" + this.trabajadores[_i].TURNO,
              HORAS: "" + this.trabajadores[_i].HORAS,
              ACTIVO: "" + this.trabajadores[_i].ACTIVO
            });

              this.posicion++;
            }
            else 
            {
              break;
            }
          }
            this.posicion = this.posicion + 5;
          
          infiniteScroll.complete();
        }, 500);
    } // fin Funcion doInfinite

  expandir(index){

   if (index=='A'){
      for (var _i = 0; _i < this.trabajadores.length; _i++) {

            this.trabajadores[_i].EXPANDIR = "SI";

          }
   }else{

    if (this.trabajadores[index].EXPANDIR == "SI"){
      this.trabajadores[index].EXPANDIR = "NO";
    }else{
      this.trabajadores[index].EXPANDIR = "SI";
    }
  }
  }


 

 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
         case "CODIGO":
           this.trabajadores[index].CODIGO = value;
           break;
         case "NOMBRE":
           this.trabajadores[index].NOMBRE = value;
           break;
         case "NOMBRE":
           this.trabajadores[index].NOMBRE = value;
           break;
         case "PASSWORD":
           this.trabajadores[index].PASSWORD = value;
           break;
         case "OBRA":
           this.trabajadores[index].OBRA = value;
           break;
         case "TURNO":
           this.trabajadores[index].TURNO = value;
           break;
         case "HORAS":
           this.trabajadores[index].HORAS = value;
           break;
        
         case "ACTIVO":
           this.trabajadores[index].ACTIVO = value;
           break;
         case "FECHAALTA":
           this.trabajadores[index].FECHAALTA = value;
           break;
         case "PUESTO":
           this.trabajadores[index].PUESTO = value;
           break;
         case "PRECIOHORA":
           this.trabajadores[index].PRECIOHORA = value;
           break;
         case "EMAIL":
           this.trabajadores[index].EMAIL = value;
           break;
         case "EMPRESA":
           this.trabajadores[index].EMPRESA = value;
           break;
           case "ZONA":
            this.trabajadores[index].ZONA = value;
            break;           
          case "ALIAS":
            this.trabajadores[index].ALIAS = value;
            break;           
          case "TARJETA":
            this.trabajadores[index].TARJETA = value;
            break;           
            default:
           // code...
           break;
       }
     
    }

ponencampo(campo:string, value:string):void{
      
      switch (campo) {
         case "EMPRESA":
           this.formulario.empresa1 = value;
           break;

         case "OBRA":
           this.formulario.obra1 = value;
           break;
         case "TURNO":
           this.formulario.turno1 = value;
           break;
      
         case "ACTIVO":
           this.formulario.activo1 = value;
           break;
         
         default:
           // code...
           break;
       }
     
    }

salir(){
   this.navCtrl.push(ListPage);
}





  read(bstr: string) {

  };

  write(): XLSX.WorkBook {

           this.rs_xls = [];

           for (var _i = 0; _i < this.trabajadores.length; _i++) {

            this.rs_xls.push({
              CODIGO: "" + this.trabajadores[_i].CODIGO,
              NOMBRE: "" + this.trabajadores[_i].NOMBRE,
              EMPRESA: "" + this.trabajadores[_i].EMPRESA,
              OBRA: "" + this.trabajadores[_i].OBRA,
              TURNO: "" + this.trabajadores[_i].TURNO,
              HORAS: "" + this.trabajadores[_i].HORAS,
              ACTIVO: "" + this.trabajadores[_i].ACTIVO,
              ALIAS: "" + this.trabajadores[_i].ALIAS,
              TARJETA: "" + this.trabajadores[_i].TARJETA
            });
          }

  
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rs_xls);

  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

  return wb;
  };

  /* File Input element for browser 
  onFileChange(evt: any) {
  const target: DataTransfer = <DataTransfer>(evt.target);
  if (target.files.length !== 1) throw new Error('Cannot use multiple files');
  const reader: FileReader = new FileReader();
  reader.onload = (e: any) => {
    const bstr: string = e.target.result;
    this.read(bstr);
  };
  reader.readAsBinaryString(target.files[0]);
  };
  */

  /* Import button for mobile */
  async import() {
   /* try {
    const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
    const dentry = await this.file.resolveDirectoryUrl(target);
    const url: string = dentry.nativeURL || '';
    alert(`Attempting to read informepicajes.xlsx from ${url}`)
    const bstr: string = await this.file.readAsBinaryString(url, "relaciontickets.xlsx");
    this.read(bstr);
  } catch(e) {
    const m: string = e.message;
  }
  */
  };

  /* Export button */
  async export() {

  const wb: XLSX.WorkBook = this.write();
  const filename: string = "trabajadores.xlsx";
  try {
    /* generate Blob */
    const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([wbout], {type: 'application/octet-stream'});

    /* find appropriate path for mobile */
    const target: string = this.file.documentsDirectory || this.file.externalDataDirectory || this.file.dataDirectory || '';
    const dentry = await this.file.resolveDirectoryUrl(target);
    const url: string = dentry.nativeURL || '';

    /* attempt to save blob to file */
    await this.file.writeFile(url, filename, blob, {replace: true});

  } catch(e) {
    XLSX.writeFile(wb, filename);
  }
  };



  
  openModalWithParams(id, nombre, diasvacaciones) {

    var f = new Date();
    this.variables.selectedDay  =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;

    this.variables.IDtrabajador = id;
    this.variables.NOMBREtrabajador = nombre;
    this.variables.diasVacaciones = diasvacaciones;
    this.variables.primeravez="si";

    this.variables.volverDespuesVacaciones = TrabajadoresPage;
    
    this.navCtrl.setRoot(VacacionesPage);

  }



}



// WEBPACK FOOTER //
// ./src/pages/trabajadores/trabajadores.ts